import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

const searchParamsSchema = z.object({
	token: z.coerce.string(),
});

export const Route = createFileRoute("/auth/reset-password")({
	validateSearch: zodValidator(searchParamsSchema),
	beforeLoad({ search }) {
		throw redirect({
			to: "/",
			search: { auth: "reset_password", token: search.token },
			replace: true,
		});
	},
});
